<template>
  <b-container :class="containerClass">
    <b-row>
      <b-col>
        <slot name="before-type">
        </slot>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" sm="12" md="12" lg="12" xl="12">
        <b-form-group :label="$tc('message.type', 1)"
                      label-for="document-type">
          <b-form-select id="document-type"
                         v-model="input.tipo"
                         :options="typeOptions">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <slot name="before-input">
        </slot>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="12" md="12" lg="12" xl="12">
        <b-form-group :label="$tc('message.attachment', 1)"
                      label-for="input-file">
          <b-form-file id="input-file"
                       v-model="input.file"
                       browse-text="aaaaa"
                       :class="`lang-${$i18n.locale}`"
                       :placeholder="`${$t('message.select')} ${$tc('message.attachment', 1).toLowerCase()}`"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <slot name="before-notes">
        </slot>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" sm="12" md="12" lg="12" xl="12">
        <b-form-group :label="$tc('message.note', 2)"
                      label-for="input-file">
          <b-form-textarea id="document-notes"
                           v-model="input.note"
                           :placeholder="$tc('message.note', 2)"
                           rows="3"
                           max-rows="6"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'FileUploader',
  props: ['fullWidth', 'noContainerPadding'],
  mounted () {
    this.containerClass = this.getContainerClass()
    this.typeOptions = this.getOptions()
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.typeOptions = this.getOptions()
      }
    })
  },
  data () {
    return {
      containerClass: '',
      input: {
        tipo: null,
        file: null
      },
      typeOptions: []
    }
  },
  methods: {
    getContainerClass () {
      let classResult = ''
      classResult += this.fullWidth ? 'mw-100 ' : ''
      classResult += this.noContainerPadding ? 'p-0 ' : ''
      return classResult
    },
    getOptions () {
      const options = [{ value: null, text: this.$t('message.selectOption') }]
      Vue.myGet(this, '/enums/document_type', 'data').then((items) => {
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        return options
      })
      return options
    }
  }
}
</script>

<style scoped>
</style>
